<div class="row m-0">
  <div class="col-12 page-heading-wrapper">
    <gb-ui-page-heading [titleText]="pageTitle" [displayBacklink]="true" [backLinkText]="'COMMON.BACK' | translate"
      (back)="routerGoBack()"></gb-ui-page-heading>
  </div>
</div>
<div class="govuk-width-container">
  <div class="row">
    <div class="col-sm-12">
      <ui-stepper [steps]="steps"></ui-stepper>
    </div>
  </div>
  <div *ngIf="selectedDepartment" id="main-content" tabindex="-1">
    <div class="row">
      <div class="col-12">
        <h1 style="margin: 0;">{{datastoreService?.pageContent?.calendar_page_subtitle}}</h1>
        <p class="body-xl">Choose a date and time</p>

        @if (agentMode) { 
        <button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
          (click)="datastoreService?.agentRestart()">
          Agent Restart
        </button>
         }

        <hr>
      </div>
    </div>

    <app-mat-calendar [service]="selectedService" [location]="selectedLocation" [component]="component"
      [slotSelectionError]="slotSelectionError" (nextClicked)="continue()" class="row">
    </app-mat-calendar>

    <br />
    <br />
    <div class="row pb-4">
      <div class="col-sm-12">
        <button *ngIf="selectedDepartment" type="submit fr" class="govuk-button govuk-button--inverse next-btn"
          (click)="continue()">
          {{ 'COMMON.NEXT' | translate }}
        </button>
      </div>

    </div>
  </div>

</div>
